import { render } from "./page-calendar.vue?vue&type=template&id=3ddeef2d"
import script from "./page-calendar.vue?vue&type=script&lang=js"
export * from "./page-calendar.vue?vue&type=script&lang=js"

import "./page-calendar.vue?vue&type=style&index=0&id=3ddeef2d&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__